import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.recruitments.tasks');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-recruitments-tasks',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.recruitments.tasks/view.scss */
/* src/app/page.recruitments.tasks/view.scss: no such file or directory */`],
})
export class PageRecruitmentsTasksComponent implements OnInit {
    public id: string = "";
    public loading: boolean = true;
    public syncing: boolean = false;
    public actionTaskId: string = "";
    public payload: any = null;
    public uiPolicy: any = {
        solo_admin_mode: true,
        solo_admin_applies: false
    };
    public items: any[] = [];
    public accessError: string = "";
    public syncApplicantId: string = "";
    public syncMessage: string = "";
    public filters: any = {
        status: "",
        priority: "",
        task_type: ""
    };

    constructor(@Inject( Service) public service: Service) {
        this.id = WizRoute.segment.id;
    }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        await this.load();
    }

    public async load() {
        this.loading = true;
        this.accessError = "";
        await this.service.render();

        const { code, data, message } = await wiz.call("get_recruitment_tasks", {
            id: this.id,
            recruitment_id: this.id,
            status: this.filters.status,
            priority: this.filters.priority,
            task_type: this.filters.task_type
        });
        if (code === 200 && data?.ok !== false) {
            this.payload = data;
            this.updateUiPolicy(data);
            this.items = data.items || [];
        } else {
            this.payload = null;
            this.items = [];
            this.accessError = this.safeErrorMessage(code, message || data?.message, "전형 업무큐 조회 중 오류가 발생했습니다.");
        }

        this.loading = false;
        await this.service.render();
    }

    public statusOptions() {
        return this.payload?.statuses || [{ key: "", label: "전체" }];
    }

    public priorityOptions() {
        return this.payload?.priorities || [{ key: "", label: "전체" }];
    }

    public taskTypeOptions() {
        return this.payload?.task_types || [{ key: "", label: "전체" }];
    }

    public async applyFilters() {
        await this.load();
    }

    public async resetFilters() {
        this.filters = { status: "", priority: "", task_type: "" };
        await this.load();
    }

    public async syncApplicantTasks() {
        if (this.syncing) return;
        if (!(this.syncApplicantId || "").trim()) {
            await this.service.modal.error("지원자 ID를 입력해주세요.");
            return;
        }

        this.syncing = true;
        this.syncMessage = "";
        await this.service.render();

        const { code, data, message } = await wiz.call("sync_applicant_tasks", {
            applicant_id: this.syncApplicantId
        });
        this.syncing = false;

        if (code === 200 && data?.ok !== false) {
            this.syncMessage = `생성 ${data.created_count || 0}건 · 재사용 ${data.reused_count || 0}건 · 보존 ${data.preserved_count || 0}건`;
            await this.load();
            return;
        }

        await this.service.modal.error(this.safeErrorMessage(code, message || data?.message, "지원자 업무 동기화 중 오류가 발생했습니다."));
        await this.service.render();
    }

    public async completeTask(item: any) {
        if (!item?.id || this.actionTaskId) return;
        this.actionTaskId = item.id;
        await this.service.render();

        const { code, data, message } = await wiz.call("complete_task", { task_id: item.id });
        this.actionTaskId = "";
        if (code === 200 && data?.ok !== false) {
            await this.load();
            return;
        }

        await this.service.modal.error(this.safeErrorMessage(code, message || data?.message, "업무 완료 처리 중 오류가 발생했습니다."));
        await this.service.render();
    }

    public async dismissTask(item: any) {
        if (!item?.id || this.actionTaskId) return;
        this.actionTaskId = item.id;
        await this.service.render();

        const { code, data, message } = await wiz.call("dismiss_task", { task_id: item.id });
        this.actionTaskId = "";
        if (code === 200 && data?.ok !== false) {
            await this.load();
            return;
        }

        await this.service.modal.error(this.safeErrorMessage(code, message || data?.message, "업무 숨김 처리 중 오류가 발생했습니다."));
        await this.service.render();
    }

    public openDetail(item: any) {
        if (!item?.detail_url) return;
        location.href = item.detail_url;
    }

    public updateUiPolicy(data: any) {
        const policy = data?.ui_policy || data?.permissions?.ui_policy || null;
        if (policy) this.uiPolicy = { ...this.uiPolicy, ...policy };
    }

    public soloAdminMode() {
        return !!this.uiPolicy?.solo_admin_mode && !!this.uiPolicy?.solo_admin_applies;
    }

    public compactStatusLabel(label: any) {
        const text = String(label || "").trim();
        if (!text) return "";
        if (text.includes("권한")) return text;
        if (/담당자 확인 필요|관리자 확인 필요|관리자 확정 필요|수동검토 필요|기준 확정 필요/.test(text)) return "확인 필요";
        if (text.includes("자동 산정 초안")) return "초안";
        return text;
    }

    public displayLabel(label: any) {
        return this.soloAdminMode() ? this.compactStatusLabel(label) : label;
    }

    public safeErrorMessage(code: number, message: string, fallback: string) {
        if (code === 403) return "권한이 필요합니다.";
        const text = String(message || "").trim();
        if (!text || /Traceback|File \"|\/opt\/|storage_key|file_path|<html/i.test(text)) return fallback;
        return text.length > 140 ? `${text.slice(0, 140).trim()}...` : text;
    }

    public badgeClass(status: any) {
        const value = String(status || "");
        if (["COMPLETED", "READ"].includes(value)) return "bg-emerald-50 text-emerald-700 border border-emerald-200";
        if (["DISMISSED"].includes(value)) return "bg-zinc-100 text-zinc-500 border border-zinc-200";
        if (["URGENT", "HIGH", "UNREAD"].includes(value)) return "bg-rose-50 text-rose-700 border border-rose-200";
        if (["IN_PROGRESS", "NORMAL"].includes(value)) return "bg-amber-50 text-amber-700 border border-amber-200";
        return "bg-zinc-50 text-zinc-600 border border-zinc-200";
    }
}

export default PageRecruitmentsTasksComponent;